import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="artist-editor"
export default class extends Controller {
  static targets = ["sortingKey", "form"];

  update(event) {
    event.preventDefault();

    const url = event.currentTarget.href;

    fetch(url, {
      headers: { "Accept": "application/json" }} )
        .then(response => response.json())
        .then(data => {
          this.sortingKeyTarget.innerHTML = data.html;
        })
        .catch(error => {
          console.error("Error loading artist sorting key editor:",error);
        });
  }

  submitForm(event) {
    // This kludge gives the DOM time to load...
    console.error("Targets in submitForm:", this.hasSortingKeyTarget, this.sortingKeyTarget);

    event.preventDefault();

    const form = event.target;
    const url = form.action;
    const formData = new FormData(form);

    fetch(url, {
      method: "PATCH",
      headers: { "Accept": "application/json" },
      body: formData
    })
      .then(response => response.json())
      .then(data => {

        // Replace the form area with the updated value
        this.sortingKeyTarget.innerHTML = "";

        const displayElement = document.querySelector("#db-key");
        if (displayElement) {
          displayElement.textContent = data.mldb_key;
        }

        // Optionally restore the "Edit Sorting Key..." link
        this.sortingKeyTarget.innerHTML = data.editor_link_html;
      })
      .catch(error => {
        console.error("Error submitting artist sorting key form:", error);
      });
  }
}
